import { render, staticRenderFns } from "./AIServices.vue?vue&type=template&id=2c1f66ea"
import script from "./AIServices.vue?vue&type=script&lang=js"
export * from "./AIServices.vue?vue&type=script&lang=js"
import style0 from "./AIServices.vue?vue&type=style&index=0&id=2c1f66ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports